import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SkeletonAnimation } from '../../skeleton-loader.types';

@Component({
  selector: 'cm-skeleton-navbar',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-navbar.component.html',
  styleUrl: './skeleton-navbar.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonNavbarComponent {
  public readonly animation = input<SkeletonAnimation>('shimmer');
}
